/**
 * Native replacement for lodash `shuffle`. Returns a new array containing the
 * elements of `collection` in a random order, using a Fisher–Yates shuffle.
 * Does not mutate the input. A nullish collection yields an empty array
 * (matching lodash). Only array inputs are supported (which is all we use).
 */
export default function shuffle<T>(collection: readonly T[] | null | undefined): T[] {
    const result = [...(collection ?? [])];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}
